import { FC, useEffect, useState } from "react"
import { Button } from '../../../../components/Button/Button'
import { Input } from '../../../../components/Input/Input'
import { AggregatorClassification, CreateAggregatorClassificationDto, Icon, PageOptions, SectionType, SegmentPluginspace } from "./../aggregadorCategory.type"
import { useAggregatorCategory } from "./../factory/useAggregadorCategory"
import { ModalWrapper } from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import { Loading } from '../../../../components/Loading/Loading'
import { GET, POST } from '../../../../services/api'
import { i18n } from "../../../../translate/i18n"
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import Swal from "sweetalert2"
import { useNavigate } from "react-router-dom"
import useModals from "../../../../hooks/useModals"
import SVG from 'react-inlinesvg'

export const AggregadorSubCategoryCreate: FC = () => {
    const navigate = useNavigate()
    const { showWrapperModal } = useModals()
    const { createAggregatorClassification, getAggregatorAllClassification } = useAggregatorCategory()

    const [searchIcon, setSearchIcon] = useState<string>('')
    const [icones, setIcones] = useState<Icon[]>([])
    const [iconesFiltered, setIconesFiltered] = useState<Icon[]>([])
    const [classifications, setClassifications] = useState<AggregatorClassification[]>([])


    const [form, setForm] = useState<CreateAggregatorClassificationDto>({
        name: '',
        description: '',
        status: true,
        svgwebappId: 0,
        order: 0,
        parentId: null,
        pluginspaceSegmentId: 0,
        type: SectionType.CATEGORY
    })

    const [categorySelecionado, setCategorySelecionado] = useState<any>(null)

    const [isLoading, setIsLoading] = useState(false)

    const handleInputChange = (field: keyof CreateAggregatorClassificationDto, value: any) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }))
    }

    function handleSelectCategory(aggregatorClassification: AggregatorClassification) {
        handleInputChange('parentId', aggregatorClassification.id)
        handleInputChange('pluginspaceSegmentId', aggregatorClassification.pluginspaceSegmentId)
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setIsLoading(true)
        try {
            await createAggregatorClassification(form)
            Swal.fire({
                icon: 'success',
                titleText: 'Sucesso',
                text: 'Classificação criada com sucesso!',
            }).then(() => {
                navigate(-1)
            })
        } catch (error) {
            console.error('Erro ao criar classificação:', error)
        } finally {
            setIsLoading(false)
        }
    }

    const handleSearchIcon = (value: string) => {
        setSearchIcon(value)
        filterIcons(value)
    }
    const filterIcons = (searchTerm: string) => {
        if (!searchTerm.trim()) {
            setIconesFiltered(icones)
        } else {
            const filtered = icones.filter(
                (icon) =>
                    icon.description && icon.description.toLowerCase().includes(searchTerm.toLowerCase())
            )
            setIconesFiltered(filtered)
        }
    }

    async function getIcones() {
        try {
            const res = await GET('svgwebapp')
            if (!res || !res.success) {
                Swal.fire({
                    icon: 'error',
                    titleText: 'Erro',
                    text: 'Erro ao encontrar os tipos',
                })
                return
            }
            setIcones(res.data)
            setIconesFiltered(res.data)
        } catch (error) {
            console.log(error)
            Swal.fire({
                icon: 'error',
                titleText: 'Erro',
                text: 'Erro ao encontrar os tipos',
            })
        }
    }

    async function getClassifications() {
        try {
            const classifications:AggregatorClassification[] = await getAggregatorAllClassification()
            //filtrar somente os que são pai
            const filteredClassifications = classifications.filter(c => c.parentId === null)
            setClassifications(filteredClassifications)
        } catch (error) {
            console.log(error)
        }
    }

    async function loadPage() {
        setIsLoading(true)
        await Promise.all([getIcones(), getClassifications()])
        setIsLoading(false)
    }

    useEffect(() => {
        loadPage()
    }, [])

    if (isLoading) {
        return <Loading />
    }

    return (
        <>
            <div className='row g-5 gx-xxl-12'>
                <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                    <div className='card-header py-5'>
                        <h3 className='card-title align-items-start flex-column'>
                            <span className='card-label fw-bolder fs-3 mb-1'>{`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.category`)}`}</span>
                            <BreadCrumbs />
                            <span className='text-muted mt-1 fw-bold fs-7'>
                                Preencha as informações abaixo e clique no botão salvar para criar uma nova
                                categoria.
                            </span>
                        </h3>
                    </div>
                    <div className='card-body'>
                        <div className='row pb-6'>
                            <div className='col d-flex justify-content-between'>
                                <div className='row'>
                                    <div className='col-12 col-md-8 pb-6' style={{ zIndex: 500 }}>
                                        <div className='d-flex gap-2'>
                                            <span>Categoria</span>
                                            <div className='d-flex gap-2'>
                                                <span className='text-muted'>·</span>
                                                <span className='text-muted'>
                                                    Escolha a categoria relacionada à nova subcategoria
                                                </span>
                                            </div>
                                        </div>
                                        <Input
                                            inputAttr={{
                                                type: 'select',
                                            }}
                                            options={classifications.map(s => ({ select: s.name, value: s.id }))}
                                            placeholder={'Categoria'}
                                            search={true}
                                            value={categorySelecionado}
                                            change={(value: any) => {
                                                setCategorySelecionado(value)
                                                const selectedClassification = classifications.find(c => c.id === Number(value.value))
                                                if (!selectedClassification) return
                                                handleSelectCategory(selectedClassification)
                                            }}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <div className='d-flex gap-2'>
                                            <span>Subcategoria</span>
                                            <div className='d-flex gap-2'>
                                                <span className='text-muted'>·</span>
                                                <span className='text-muted'>Máximo de 15 caracteres</span>
                                            </div>
                                        </div>
                                        <Input
                                            inputAttr={{
                                                type: 'text',
                                            }}
                                            placeholder={'Subcategoria'}
                                            value={form.name}
                                            change={(value: string) => handleInputChange('name', value.substring(0, 15))}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <Input
                                        inputAttr={{
                                            type: 'icon',
                                        }}
                                        onAction={() => showWrapperModal('Ícones')}
                                        label='Ícone'
                                        value={icones.find((icon) => icon.id === form.svgwebappId) || ''}
                                        change={(value: any) => {
                                            handleInputChange('svgwebappId', value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row pb-6'>
                            <div className='col-6 col-md-2'>
                                <div>
                                    <span>Tipo de Página</span>
                                    <Input
                                        inputAttr={{
                                            type: 'select',
                                        }}
                                        options={PageOptions.map(s => ({ select: s.select, value: s.value }))}
                                        value={form.type}
                                        change={(value: SectionType) => handleInputChange('type', value)}
                                    />
                                </div>
                            </div>
                            <div className='col-6 col-md-2'>
                                <div>
                                    <span>Ordem</span>
                                    <Input
                                        inputAttr={{
                                            type: 'number',
                                        }}
                                        placeholder={'0'}
                                        value={form.order}
                                        change={(value: number) => handleInputChange('order', value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <div>
                                    <span>Descrição</span>
                                    <Input
                                        rows={4}
                                        inputAttr={{
                                            type: 'textarea',
                                        }}
                                        placeholder={'Descrição'}
                                        value={form.description}
                                        change={(value: any) => {
                                            handleInputChange('description', value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between mt-5'>
                            <Button
                                text='Voltar'
                                color='info'
                                size='small'
                                horizontalPadding={6}
                                btnAttr={{
                                    type: 'button',
                                }}
                                click={() => {
                                    Swal.fire({
                                        title: 'Você tem certeza?',
                                        text: 'Os dados que foram digitados serão perdidos.',
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Sim, voltar!',
                                        cancelButtonText: 'Não, cancelar!',
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            navigate(-1)
                                        }
                                    })
                                }}
                                btnClass='fw-bolder'
                            />
                            <Button
                                text='Salvar'
                                color='primary'
                                size='small'
                                horizontalPadding={6}
                                btnAttr={{
                                    type: 'button',
                                }}
                                click={(e) => handleSubmit(e)}
                                btnClass='fw-bolder'
                            />
                        </div>
                    </div>
                </div>
            </div>

            <ModalWrapper confirmAction={() => { }} maxWidth={true} width={40}>
                <div
                    className='d-flex flex-column gap-5 card'
                    style={{
                        height: '30rem', // Reduzir de 25rem para 23rem
                    }}
                >
                    <div
                        className='d-flex justify-content-between align-items-start pt-4 px-4'
                        style={{ paddingBottom: '15px' }}
                    >
                        <div className='d-flex flex-column' style={{ width: '300px', gap: '4px' }}>
                            <span className='fw-bold'>Buscar ícone</span>
                            <div className='position-relative'>
                                <Input
                                    inputAttr={{
                                        type: 'text',
                                        style: {
                                            paddingRight: '40px',
                                            height: '38px',
                                            width: '100%',
                                        },
                                    }}
                                    placeholder='Digite para buscar...'
                                    value={searchIcon}
                                    change={(value: string) => handleSearchIcon(value)}
                                />
                                <i
                                    className='fas fa-search position-absolute text-muted'
                                    style={{
                                        right: '14px',
                                        top: '62%',
                                        transform: 'translateY(-50%)',
                                        pointerEvents: 'none',
                                        fontSize: '14px',
                                        zIndex: 10,
                                    }}
                                />
                            </div>
                        </div>
                        <div className='d-flex flex-column align-items-center gap-2'>
                            <span className='fw-bold text-center'>Ícone selecionado</span>
                            <div
                                className='p-4 border border-primary rounded'
                                style={{
                                    minHeight: '77px',
                                    minWidth: '77px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {form.svgwebappId ? (
                                    <SVG
                                        src={icones.find((icon) => icon.id === form.svgwebappId)?.svg || ''}
                                        style={{
                                            width: '45px',
                                            height: '45px',
                                        }}
                                    />
                                ) : (
                                        <span className='text-muted fs-7'>Selecione um ícone</span>
                                    )}
                            </div>
                        </div>
                    </div>
                    <div
                        className='card-body d-flex gap-3 flex-row flex-wrap overflow-auto'
                        style={{ padding: '20px' }}
                    >
                        {iconesFiltered.map((icon) => (
                            <div
                                key={icon.id}
                                className={`d-flex flex-column align-items-center p-3 cursor-pointer rounded ${form.svgwebappId === icon.id
                                    ? 'border border-primary bg-light-primary'
                                    : 'border border-light hover-shadow'
                                    }`}
                                onClick={() => setForm({ ...form, svgwebappId: icon.id })}
                                style={{
                                    width: '120px',
                                    height: '100px',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <SVG
                                    src={icon.svg}
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        marginBottom: '8px',
                                    }}
                                />
                                <span
                                    className='text-center text-truncate fw-bold'
                                    style={{
                                        fontSize: '11px',
                                        width: '100%',
                                        lineHeight: '1.2',
                                    }}
                                    title={icon.description || 'Sem descrição'}
                                >
                                    {icon.description || 'Sem descrição'}
                                </span>
                            </div>
                        ))}
                        {iconesFiltered.length === 0 && searchIcon && (
                            <div className='d-flex justify-content-center align-items-center w-100'>
                                <div className='text-center'>
                                    <i className='fas fa-search fs-2 text-muted mb-3'></i>
                                    <p className='text-muted mb-0'>Nenhum ícone encontrado</p>
                                    <small className='text-muted'>Tente uma palavra-chave diferente</small>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </ModalWrapper>
        </>
    )
}